import { graphql, useStaticQuery } from 'gatsby';
export const useFeaturedProjects = () => {
    const query = useStaticQuery(graphql `
      query useFeaturedProjectsQuery {
        cosmos {
          pages {
            home(dataKey: "page") {
              featured_projects_copy {
                header
                description
                icon {
                  ticket
                  fileName
                }
              }
              featured_projects {
                client_name
                client_brand_color
                client_logo {
                  ticket
                  fileName
                }
                project_description_short
                project_cover_image {
                  ticket
                  fileName
                }
                project_transparent_bg_mockup {
                  ticket
                  fileName
                }
                project_quote {
                  quote_text
                  author_name
                  author_position
                  author_photo {
                    ticket
                    fileName
                  }
                }
                project_types {
                  name
                  icon {
                    ticket
                  }
                }
              }
            }
          }
        }
      }
    `);
    return {
        projects: query.cosmos.pages.home.featured_projects,
        copy: query.cosmos.pages.home.featured_projects_copy,
    };
};
export default useFeaturedProjects;
